const baseUrl = '/api/v1/order';
export const proceedOrderUrl = `${baseUrl}/proceed`;

// Tenant is not used in core SWAG therefore empty URL
export const getTenantOrdersUrl = '';
export const proceedDutyOrderUrl = `${baseUrl}/proceed-duty-order`;
export const proceedAdminUrl = '';